export function makeNotifications(payload) {
	return payload.map(notification => makeNotification(notification));
}

export function makeNotification(payload) {
	return new Notification(payload.read, payload.message, payload.dateTime);
}

class Notification {
	constructor(isRead, message, dateTime) {
		this.isRead = isRead;
		this.message = message;
		this.dateTime = dateTime;
	}
}

export default Notification;



// WEBPACK FOOTER //
// ./client/app/shared/models/notification-model.js